import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AttachmentsService } from 'src/app/services/attachments/attachments.service';

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss']
})
export class HomePageComponent implements OnInit, AfterViewInit {
  constructor(private readonly attachmentsService: AttachmentsService) {
    this.dataSource = new MatTableDataSource();
  }

  dataSource: MatTableDataSource<any>;

  displayedColumns: string[] = [
		"descrizione",
		"azioni",
	];
  totalItems: number = 0;
	pageSize: number = 10;
	pageSizeOptions: number[] = [5, 10, 25, 100];
  pageIndex = 0;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

	currentPage: number;

  public ngAfterViewInit(): void {
    this.currentPage = 0;
		this.pageSize = 10;
	}

  public onPageChange(event: PageEvent) {
		this.currentPage = event.pageIndex;
		this.loadDatatable();
	}

  ngOnInit(): void {
    this.loadDatatable();
  }

  loadDatatable () {
      this.attachmentsService.ricercaHomePageAllegati(this.pageIndex, this.pageSize).subscribe({
      next: (response: any) => {
        this.totalItems = response.result.count;

        this.dataSource = new MatTableDataSource(response.result.listaAllegati);
        this.dataSource.sort = this.sort;
      }
    })
  }

  downloadAllegato(documento:any) {
    let data = {
      valore:documento.idDocumento
    }
    this.attachmentsService.downloadDocumentoHomePage(data).subscribe(
      (data:any) => {
        let fileName: string = documento.descrizione + ".pdf";
        this.attachmentsService.downloadService(data, fileName);
      }
    )
  }

  onPaginateChange(event: any) {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;

    this.loadDatatable();
  }
}
